import React from "react";

const Badge = ({
  variant = "contained", // contained, outlined, text, dot
  size = "md", //xs, xs-sm, sm, md, lg, xl
  color = "primary", // primary, warning, success, danger, info, black, white
  children,
  className = "",
  value,
  max,
  showZero = false,
  overlap = "rectangular",
  invisible = false,
  position = "relative", // added position prop
  anchorOrigin = {
    // added anchorOrigin prop
    vertical: "top",
    horizontal: "right",
  },
}) => {
  const badgeContent = max !== undefined && value > max ? `${max}+` : value;
  const shouldDisplay = showZero ? true : value !== 0;

  const sizeStyles = {
    xs: "min-w-[14px] h-[14px] text-[10px] leading-none",
    "xs-sm": "min-w-[16px] h-[16px] text-[10px] leading-none",
    sm: "min-w-[18px] h-[18px] text-[10px] leading-none",
    md: "min-w-[18px] h-[18px] text-[10px] leading-none",
    lg: "min-w-[24px] h-[24px] text-[13px] leading-none",
    xl: "min-w-[28px] h-[28px] text-[14px] leading-none",
  };

  const colorStyles = {
    primary: {
      contained: "bg-primary text-white",
      outlined: "border-[1px] bg-primary-50 border-primary text-primary",
      text: "text-primary",
      dot: "bg-primary",
    },
    warning: {
      contained: "bg-warning text-white",
      outlined: "border-[1px] bg-warning-50 border-warning text-warning",
      text: "text-warning",
      dot: "bg-warning",
    },
    success: {
      contained: "bg-success text-white",
      outlined: "border-[1px] bg-success-50 border-success text-success",
      text: "text-success",
      dot: "bg-success",
    },
    danger: {
      contained: "bg-danger text-white",
      outlined: "border-[1px] bg-danger-50 border-danger text-danger",
      text: "text-danger",
      dot: "bg-danger",
    },
    info: {
      contained: "bg-info text-white",
      outlined: "border-[1px] bg-info-50 border-info text-info",
      text: "text-info",
      dot: "bg-info",
    },
    black: {
      contained: "bg-black text-white",
      outlined: "border-[1px] bg-gray-50 border-black text-black",
      text: "text-black",
      dot: "bg-black",
    },
    white: {
      contained: "bg-white text-gray-900",
      outlined: "border-[1px] bg-black border-white text-white",
      text: "text-white",
      dot: "bg-white",
    },
  };

  const overlapStyles = {
    rectangular: "-top-2 -right-2",
    circular: "-top-1 -right-1",
  };
  const anchorStyles = {
    "top-right": "top-0 right-0 -translate-y-2/3 translate-x-2/3",
    "top-left": "top-0 left-0 -translate-y-2/3 -translate-x-2/3",
    "center-right": "top-1/2 -right-1 -translate-y-1/2 translate-x-1/2",
    "center-left": "top-1/2 -left-1 -translate-y-1/2 -translate-x-1/2",
    "bottom-right": "bottom-0 right-0 translate-y-2/3 translate-x-2/3",
    "bottom-left": "bottom-0 left-0 translate-y-2/3 -translate-x-2/3",
  };
  const getAnchorPosition = () => {
    const key = `${anchorOrigin.vertical}-${anchorOrigin.horizontal}`;
    return anchorStyles[key] || anchorStyles["top-right"];
  };
  return (
    <div className={`inline-flex ${position}`}>
      {children}
      {!invisible &&
        shouldDisplay &&
        (variant === "dot" ? (
          <span
            className={` select-none
              absolute ${getAnchorPosition()}
              flex items-center justify-center
              rounded-full px-1
              w-2 h-2
              ${colorStyles[color][variant]}
              ${className}
              
            `}
          ></span>
        ) : (
          <span
            className={` select-none
              absolute ${getAnchorPosition()}
              flex items-center justify-center
              rounded-full px-1
              ${sizeStyles[size]}
              ${colorStyles[color][variant]}
              ${className}
              
            `}
          >
            {badgeContent}
          </span>
        ))}
    </div>
  );
};

export default Badge;
